<template>
  <div class="btn-group dropright">
    <font-awesome-icon
      :icon="['fas', 'user-circle']"
      class="text-primary"
      style="cursor: pointer"
      @click="showContact()"
    />
    <div
      :class="['dropdown-menu', this.show ? 'show' : '']"
      class="px-2 py-0 bg-light ml-2 shadow"
      :style="{width: '400px', overflowY: 'auto', lineHeight: 1, height: calculateHeight}"
    >
      <div class="text-center vertical-center" v-if="errorMsg">
          <p class="text-danger">{{ errorMsg}}</p>
      </div>
      <div class="text-center vertical-center" v-else-if="contactInfo == undefined">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
      </div>
      <div class="text-center vertical-center" v-else-if="contactInfo != undefined && !contactInfo">
          <p>No contact data available for this number</p>
      </div>
      <div class="card my-2" v-else v-for="ci in contactInfo" :key="ci.id">
        <div class="card-body">
          <h5 class="card-title font-weight-bold">{{ ci.personFullName }}</h5>
          <p class="card-text mb-0">Contact Id: {{ ci.id }}</p>
          <a :href="`mailto:${ci.emails[0].email}`">{{ ci.emails[0].email }}</a>
          <p class="card-text font-italic mt-2 mb-0">
            Created on: {{ ci.created.split('T')[0] }}
          </p>
          <a
            :href="ci.profileUrl"
            target="_blank"
            class="btn btn-primary"
            style="position: absolute; bottom: 10px; right: 10px"
            >More Info</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrmService from "@/services/crm"

export default {
  name: "ContactCard",
  props: {
      number: String,
  },
  data: () => ({
    show: false,
    contactInfo: undefined,
    errorMsg: undefined,
  }),
  computed: {
    calculateHeight() {
      return (this.contactInfo && this.contactInfo.length > 1) ? '165px' : '155px'
    }
  },
  methods: {
    showContact() {
      this.show = !this.show;
      this.errorMsg = undefined;
      if (this.show && this.contactInfo == undefined) {
          this.showInfo(this.number)
      }
    },
    async showInfo(phone) {
      try {
        this.contactInfo = await CrmService.getContactInfoByPhone(phone)
      } catch (error) {
        this.errorMsg = 'Server error while getting contact info';
      }
    },
    close(e) {
        if (!this.$el.contains(e.target)) {
            this.show = false;
        }
    }
  },
  mounted() {
      document.addEventListener('click', this.close)
  },
  beforeDestroy() {
      document.removeEventListener('click', this.close)
  }
};
</script>
<style scoped>
.vertical-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vertical-center p {
  font-size: 13pt;
}
</style>
